import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'

import { IJBPPlanningItem, SMBFractionTypes } from '../../../models/IJBPPlanning'

interface IGetEmptyPlanningItem {
  partnerId: string
  fy: number
  fq: number
  setting: IFormActualsTargetsSettings
  isActuals: number
  isDirect: number
  isTarget: number
  isQuota: number
  isNoSplit: number
  isRollUp: number
  isTotal: number
  isPartnerCount: number
  globalCategory?: string
  smbFraction?: SMBFractionTypes
}

export const getEmptyPlanningItem = ({
  partnerId,
  fy,
  fq,
  setting,
  isActuals,
  isDirect,
  isTarget,
  isQuota,
  isNoSplit,
  isRollUp,
  isTotal,
  isPartnerCount,
  globalCategory,
  smbFraction = SMBFractionTypes.Total,
}: IGetEmptyPlanningItem): IJBPPlanningItem => {
  return {
    // IJBPPlanning fields
    PartnerId: partnerId,
    FYear: fy,
    ProgramTypes: setting.ProgramType,
    Category: setting.Category,

    GlobalCategory: globalCategory,

    FQuarter: fq,
    SubCategory: setting.SubCategory,
    L3Category: setting.L3Category,

    SMBFraction: smbFraction,

    IsActuals: isActuals,
    IsDirect: isDirect,
    IsTarget: isTarget,
    IsQuota: isQuota,
    IsNoSplit: isNoSplit,
    IsRollUp: isRollUp,
    IsTotal: isTotal,
    IsPartnerCount: isPartnerCount,

    PLs: '',

    // LC
    SellThruSumLCTNet: null,
    SellThruSumLCNet: null,
    SellThruSumLCNdp: null,
    // USD
    SellThruSumUSDTNet: null,
    SellThruSumUSDNet: null,
    SellThruSumUSDNdp: null,
    // Units
    SellThruUnitsTNet: null,
    SellThruUnits: null,
    SellThruUnitsNdp: null,
    //Direct (Actuals only)
    SellThruSumUSDTNetDirect: null,
    SellThruSumUSDNetDirect: null,
    SellThruSumUSDNdpDirect: null,
    SellThruSumLCTNetDirect: null,
    SellThruSumLCNetDirect: null,
    SellThruSumLCNdpDirect: null,
    SellThruUnitsTNetDirect: null,
    SellThruUnitsDirect: null,
    SellThruUnitsNdpDirect: null,

    IsCollapsed: 0,

    // Optional fields
    //Comment: null,
    //Justification: null,
    //JustificationSob: null,
    //JustificationContractual: null,
    //JustificationTransactional: null,
    IsNoPlan: 0,
    IsNoPlanContractual: 0,

    // LC
    ContractualSumLCTNet: null,
    ContractualSumLCNet: null,
    ContractualSumLCNdp: null,
    // USD
    ContractualSumUSDTNet: null,
    ContractualSumUSDNet: null,
    ContractualSumUSDNdp: null,
    // Units
    ContractualUnitsTNet: null,
    ContractualUnits: null,
    ContractualUnitsNdp: null,
    // Direct (Actuals only)
    ContractualSumUSDTNetDirect: null,
    ContractualSumUSDNetDirect: null,
    ContractualSumUSDNdpDirect: null,
    ContractualSumLCTNetDirect: null,
    ContractualSumLCNetDirect: null,
    ContractualSumLCNdpDirect: null,
    ContractualUnitsTNetDirect: null,
    ContractualUnitsDirect: null,
    ContractualUnitsNdpDirect: null,

    SoB: null,
    SoBCompleted: null,

    Currency: '',
    NetNdp: '',

    // Partners Completeness
    ReportGUID: '',

    PartnersCount: 0,
    PartnersCountAcknowledged: 0,
    PartnersCountNotAcknowledged: 0,

    PartnersCompleted: 0,
    PartnersNotCompleted: 0,
    PartnersCompletedAcknowledged: 0,
    PartnersNotCompletedAcknowledged: 0,
    PartnersNotFullyCompleted: 0,

    SoBPartnersCompleted: 0,
    SoBPartnersNotCompleted: 0,
    SoBPartnersCompletedAcknowledged: 0,
    SoBPartnersNotCompletedAcknowledged: 0,
    SoBPartnersNotFullyCompleted: 0,

    SellThruSumUSDNdpCompleted: null,
    SellThruSumUSDNdpCompletedSob: null,
    SellThruSumUSDNetCompleted: null,
    SellThruSumUSDNetCompletedSob: null,
    SellThruUnitsNdpCompleted: null,
    SellThruUnitsCompleted: null,

    ContractualSumUSDNdpCompleted: null,
    ContractualSumUSDNdpCompletedSob: null,
    ContractualSumUSDNetCompleted: null,
    ContractualSumUSDNetCompletedSob: null,
    ContractualUnitsNdpCompleted: null,
    ContractualUnitsCompleted: null,

    // IJBPPlanningItem fields
    IsDataPresent: false,
    IsAcknowledgedDataPresent: false,
    IsChanged: 0,
    IsChangedSoB: 0,

    IsChangedSoBManual: 0,

    IsChangedManual: 0,
    IsChangedContractualManual: 0,
    IsChangedTransactionalManual: 0,

    IsChangedUnitsManual: 0,
    IsChangedUnitsContractualManual: 0,
    IsChangedUnitsTransactionalManual: 0,
  }
}
